import n from "./debounce.js";
import l from "./isObject.js";
var f = "Expected a function";
function u(t, a, r) {
  var e = !0, i = !0;
  if (typeof t != "function")
    throw new TypeError(f);
  return l(r) && (e = "leading" in r ? !!r.leading : e, i = "trailing" in r ? !!r.trailing : i), n(t, a, {
    leading: e,
    maxWait: a,
    trailing: i
  });
}
export {
  u as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/throttle.js
// module id = 1529
// module chunks = 41